<script lang="ts" setup>
import { ref, watch } from "vue";
import LocationLabelGrid from "@/components/app/homes/LocationLabelGrid.vue";
import { getLocationLabelFilterOptions, getLabelDocuments, severityCode } from "@/services/api/locationlabel.api";
import { FilterTokenName, FilterStatus, mapFilterResponseStatus } from "@/stores/filtertoken";
import handleFilterTokens27 from "@/composables/handleFilterTokens27";
import { labels } from "@/composables/miscellaneous.js";
import { useUserStore } from "@/stores/user";
import BuildingOverviewEnergyLabels from "@/components/app/buildings/BuildingOverviewEnergyLabels.vue";
import BuildingEnergyLabelAge from "@/components/app/buildings/BuildingEnergyLabelAge.vue";
import { useToast } from "vue-toastification";
import { EnergyLabelCategoryStatus } from "@/enums/EnergyLabelCategoryStatus";

const toaster = useToast();
const { mapFilterResult } = handleFilterTokens27(FilterTokenName.LocationLabel);
const userStore = useUserStore();

const filters = ref([
  {
    name: "Volledigheid",
    fieldName: "dataScore",
    type: "list",
    options: [
      { text: "OK (Groen)", id: EnergyLabelCategoryStatus.Ok },
      { text: "Waarschuwing (Oranje)", id: EnergyLabelCategoryStatus.Warning },
      { text: "Fout (Rood)", id: EnergyLabelCategoryStatus.Error },
    ],
  },
  {
    name: "Categorie",
    fieldName: "EnergyLabelCategory",
    type: "list",
    options: [
      { text: "Energielabel verlopen", filterValue: EnergyLabelCategoryStatus.Error, id: "ExpiredLabel" },
      { text: "Beschikbaar document", filterValue: "false", id: "AvailableDocument" },
      { text: "Registratiedatum komen overeen", filterValue: EnergyLabelCategoryStatus.Error, id: "LabelRegistrationDateMatch" },
      { text: "Opnamedatum komen overeen", filterValue: EnergyLabelCategoryStatus.Error, id: "LabelRecordingDateMatch" },
      { text: "label-letter komen overeen", filterValue: EnergyLabelCategoryStatus.Error, id: "LabelLettersMatch" },
      { text: "label-meetwaarden komen overeen", filterValue: EnergyLabelCategoryStatus.Error, id: "LabelMeasurementValuesMatch" },
    ],
  },
  {
    name: "VHE nummer",
    fieldName: "reference",
    type: "search",
    options: [],
    status: FilterStatus.None,
  },
  {
    name: "Complexnummer",
    fieldName: "parentReference",
    type: "search",
    options: [],
    status: FilterStatus.None,
  },
  // {
  //   name: "Omschrijving",
  //   fieldName: "description",
  //   type: "search",
  //   options: [],
  // },
  {
    name: "Adres",
    fieldName: "address",
    type: "search",
    options: [],
    status: FilterStatus.None,
  },
  {
    name: "Plaats",
    fieldName: "city",
    type: "search",
    options: [],
    status: FilterStatus.None,
  },
  // {
  //   name: "EP1",
  //   fieldName: "vabiCurrentLabelBeng1",
  //   type: "range",
  //   options: [],
  // },
  {
    name: "EP2",
    fieldName: "vabiCurrentLabelBeng2",
    type: "range",
    options: [],
    status: FilterStatus.None,
  },
  // {
  //   name: "EP3",
  //   fieldName: "vabiCurrentLabelBeng3",
  //   type: "range",
  //   options: [],
  // },
  {
    name: "Vabi Huidig Label",
    fieldName: "vabiCurrentLabel",
    type: "list",
    options: [...labels],
  },
  {
    name: "EI",
    fieldName: "vabiRegisteredEnergyIndex",
    type: "range",
    options: [],
  },
  // {
  //   name: "EP1",
  //   fieldName: "vabiRegisteredLabelBeng1",
  //   type: "range",
  //   options: [],
  // },
  {
    name: "EP2",
    fieldName: "vabiRegisteredLabelBeng2",
    type: "range",
    options: [],
  },
  // {
  //   name: "EP3",
  //   fieldName: "vabiRegisteredLabelBeng3",
  //   type: "range",
  //   options: [],
  // },
  {
    name: "Vabi label",
    fieldName: "vabiRegisteredLabel",
    type: "list",
    options: [...labels],
  },
  {
    name: "EI",
    fieldName: "epOnlineEnergyIndex",
    type: "range",
    options: [],
  },
  // {
  //   name: "EP1",
  //   fieldName: "epOnlineLabelBeng1",
  //   type: "range",
  //   options: [],
  // },
  {
    name: "EP2",
    fieldName: "epOnlineLabelBeng2",
    type: "range",
    options: [],
  },
  // {
  //   name: "EP3",
  //   fieldName: "epOnlineLabelBeng3",
  //   type: "range",
  //   options: [],
  // },
  {
    name: "EPOnline label",
    fieldName: "epOnlineLabel",
    type: "list",
    options: [...labels],
  },
  // {
  //   name: "Certificaat",
  //   fieldName: "certificate",
  //   type: "search",
  //   options: [],
  // },
]);

async function handleFilterSearch(index, text) {
  console.log("LoactionlabelOverview handleFilterSearch filterData: ", index, text);
  let result = [];
  let status = FilterStatus.None;
  switch (filters.value[index].fieldName) {
    case "dataScore":
      {
        console.log("getFilterOptions, filters.value[index]: ", filters.value[index]);
        result = filters.value[index].options;
      }
      break;
    case "vabiCurrentLabel":
      result = filters.value[index].options;
      break;
    case "vabiRegisteredLabel":
      result = filters.value[index].options;
      break;
    case "epOnlineLabel":
      result = filters.value[index].options;
      break;
    default:
      if (text && text.length > 0) {
        const response = await getLocationLabelFilterOptions(partyReference.value, filters.value[index].fieldName, text);
        //console.log("LoactionlabelOverview handleFilterSearch response: ", response);
        status = mapFilterResponseStatus(response.severity, response.code);
        if (status === FilterStatus.Success) {
          result = response.data.data;
        } else {
          if (status === FilterStatus.Error) {
            toaster.error("Ophalen van de data is mislukt! " + response.message);
          }
        }
      }
      break;
  }
  filters.value[index].status = status;
  filters.value[index].options = mapFilterResult(result);
}

async function handleFiltersChanged(newFilterData) {
  let categoryFilters = [];
  const categoryIndex = newFilterData.findIndex((x) => x.fieldName === "EnergyLabelCategory");
  if (categoryIndex >= 0) {
    let filterData = [];
    let categoryOptions = filters.value.find((x) => x.fieldName === "EnergyLabelCategory");

    newFilterData[categoryIndex].exact.map((x) => {
      const filterOption = categoryOptions?.options.find((y) => y.id === x);
      categoryFilters.push({
        fieldName: filterOption?.id,
        exact: [filterOption?.filterValue],
      });
    });

    filterData.value = [...categoryFilters];
  }
  console.log("LoactionlabelOverview handleFiltersChanged filterData: ", newFilterData);
  if (newFilterData.length > 0) {
    gridLoaded.value = false;
    filterData.value = [...newFilterData, ...categoryFilters];
  } else {
    filterData.value = [];
  }
}

const partyReference = ref();
const filterData = ref([]);
const gridLoaded = ref(false);
const downloadBusy = ref(false);

watch(
  () => userStore.currentPartyReference,
  () => {
    partyReference.value = userStore.currentPartyReference.toString();
    filterData.value = [];
  },
  { immediate: true }
);

function dataLoaded() {
  gridLoaded.value = true;
}

async function downloadDocuments() {
  downloadBusy.value = true;
  const response = await getLabelDocuments(partyReference.value, filterData.value);
  console.log("LoactionlabelOverview downloadDocuments ", response);
  if (response.severity <= severityCode.warning) {
    console.log("LoactionlabelOverview downloadDocuments ", response);
    saveToFile(response.filename, response.data);
  } else {
    toaster.error("Ophalen van energielabels is mislukt! ", response.message);
  }
  downloadBusy.value = false;
  return response;
}

function saveToFile(name, data) {
  console.log("LoactionlabelOverview saveToFile ", name);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data);
  a.download = name;
  a.click();
}
</script>

<template>
  <BasePage>
    <v-container fluid class="app-locationlabel-overview">
      <v-row>
        <v-col class="app-welcome-message">
          <h1>Overzicht van energielabels</h1>
          <p>In dit overzicht worden alle Vabi en EPOnline energielabels van woningen in uw portefeuille getoond. Aan de hand van het filter kunt u uw gewenste inzicht creëren.</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="3" sm="6">
          <building-overview-energy-labels v-if="partyReference && gridLoaded" :partyReference="partyReference" :filterData="filterData" partyType="EnergyLabels" labelSource="VabiApi">
            <template v-slot:headerwidget>
              <h3>Verdeling huidige VABI labels</h3>
            </template>
          </building-overview-energy-labels>
        </v-col>
        <v-col md="3" sm="6">
          <BuildingOverviewEnergyLabels v-if="partyReference && gridLoaded" :partyReference="partyReference" :filterData="filterData" partyType="EnergyLabels" labelSource="EPOnline">
            <template v-slot:headerwidget>
              <h3>Verdeling EPOnline labels</h3>
            </template>
          </BuildingOverviewEnergyLabels>
        </v-col>
        <v-col md="2" sm="3">
          <BuildingEnergyLabelAge v-if="partyReference && gridLoaded" :partyReference="partyReference" :filterData="filterData" labelSource="EPOnline">
            <template v-slot:headerwidget>
              <h3>Leeftijd EPOnline labels</h3>
            </template>
          </BuildingEnergyLabelAge>
        </v-col>
      </v-row>
      <v-row class="overview-wrapper">
        <v-col>
          <article class="inner">
            <filter-set :name="FilterTokenName.LocationLabel" :filters="filters" @filter-search="handleFilterSearch" @filters-changed27="handleFiltersChanged">
              <template #append>
                <v-tooltip v-if="downloadBusy" location="top" text="Bezig met downloaden">
                  <template v-slot:activator="{ props }">
                    <v-progress-circular v-bind="props" indeterminate color="primary" size="28"></v-progress-circular>
                  </template>
                </v-tooltip>
                <v-btn v-else color="primary" @click="downloadDocuments()">
                  <v-icon>mdi-file-download</v-icon>
                  download (meerdere) labels
                </v-btn>
              </template>
            </filter-set>
            <location-label-grid :partyReference="partyReference" :filterData="filterData" @fetch-data-complete="dataLoaded"></location-label-grid>
          </article>
        </v-col>
      </v-row>
    </v-container>
  </BasePage>
</template>
